import { TOTAL_NUMBERS } from '../../../core/constants/lottery';
import { MAX_QUERY_LENGTH, STORE_PAGE_SIZE } from '../../../core/constants/store';
import { padNumber } from '../../../core/lottery/draw';

// Pure helpers for the number grid. No React, no context (TSS vite/01).

export function sanitizeQuery(value) {
    return String(value ?? '').replace(/\D/g, '').slice(0, MAX_QUERY_LENGTH);
}

// A prefix query maps to a contiguous range: '04' covers 0400–0499. Deriving
// the bounds beats filtering 10.000 strings on every keystroke.
export function rangeForQuery(query) {
    if (!query) return { start: 0, end: TOTAL_NUMBERS };
    const size = 10 ** (MAX_QUERY_LENGTH - query.length);
    const start = Number(query) * size;
    return { start, end: start + size };
}

export function buildMatches(query, onlyAvailable, isTaken) {
    const { start, end } = rangeForQuery(query);
    const matches = [];
    for (let value = start; value < end; value += 1) {
        if (onlyAvailable && isTaken(value)) continue;
        matches.push(value);
    }
    return matches;
}

export function pageCount(total, size = STORE_PAGE_SIZE) {
    return Math.max(1, Math.ceil(total / size));
}

export function clampPage(page, total, size = STORE_PAGE_SIZE) {
    return Math.min(Math.max(1, page), pageCount(total, size));
}

export function pageSlice(matches, page, size = STORE_PAGE_SIZE) {
    const start = (page - 1) * size;
    return matches.slice(start, start + size);
}

export function toTicketNumber(value) {
    return padNumber(value);
}
